import React from 'react'
import VideoIcon from '../../elements/icons/VideoIcon'
import AudioIcon from '../../elements/icons/AudioIcon'
import TextIcon from '../../elements/icons/TextIcon'
import { slugify } from '../../../utils'
import ArrowDownTrayIcon from '../../elements/icons/ArrowDownTrayIcon'
import CameraIcon from '../../elements/icons/CameraIcon'

const DownloadableCardMinified = ({downloadable}) => {
    const handleDownload = async() => {
        // URL of the file to download
        const fileUrl = downloadable.documentUrl;
        const fileName = slugify(downloadable.name); // Optional custom filename
    
        try {
            // Fetch the file as a blob
            const response = await fetch(fileUrl);
      
            if (!response.ok) {
              throw new Error('Failed to fetch file');
            }
      
            const blob = await response.blob();
      
            // Create a blob URL
            const blobUrl = URL.createObjectURL(blob);
      
            // Create an anchor element
            const anchor = document.createElement('a');
            anchor.href = blobUrl;
            anchor.download = fileName;
      
            // Append and trigger the download
            document.body.appendChild(anchor);
            anchor.click();
      
            // Cleanup
            anchor.remove();
            URL.revokeObjectURL(blobUrl);
          } catch (error) {
            console.error('Error downloading file:', error);
          }
      
    };
    return (
        <div className='w-full flex items-start gap-x-[10px]'>
            <div className='w-[30px]'>
                <div className='bg-gray-50 flex items-center justify-center h-[30px] w-[30px]'
                >
                    {downloadable.documentType === 'VIDEO' && <VideoIcon className={`w-8 h-8 text-gray-500`} />}
                    {downloadable.documentType === 'AUDIO' && <AudioIcon className={`w-8 h-8 text-gray-500`} />}
                    {downloadable.documentType === 'IMAGE' && <CameraIcon className={`w-8 h-8 text-gray-500`} />}
                    {downloadable.documentType === 'DOCUMENT'  && <TextIcon className={`w-8 h-8 text-gray-500`} />}

                </div>
            </div>

            <div className=''>
                <div className=''>
                    <p className='text-[14px] font-[500]'>{downloadable.name}</p>
                    <p className='text-[13px] my-[5px]'>{downloadable.description}</p>
                    <button onClick={()=>{handleDownload()}} className='py-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-800 hover:text-vcm-purple flex items-center gap-x-1 text-sm'>
                        <ArrowDownTrayIcon className={`w-4 h-4`} />
                        Download File
                    </button>
                </div>
                {/* <p className='text-[13px] mb-[10px]'>{downloadable.description}</p>
                <div className='flex items-center gap-x-[10px] mb-[10px]'>
                    {downloadable.documentType === 'VIDEO' && <VideoIcon className={`w-5 h-5 text-gray-500`} />}
                    {downloadable.documentType === 'AUDIO' && <AudioIcon className={`w-5 h-5 text-gray-500`} />}
                    {downloadable.documentType === 'IMAGE' && <CameraIcon className={`w-5 h-5 text-gray-500`} />}
                    {downloadable.documentType === 'DOCUMENT'  && <TextIcon className={`w-5 h-5 text-gray-500`} />}
                    
                    <p className='capitalize text-sm'>{downloadable.documentType.toLowerCase()} Created {transactionTimeStamp(downloadable.createdAt).date}</p>

                </div> */}
                
            </div>
        </div>
    )
}

export default DownloadableCardMinified